module.exports = __webpack_public_path__ + "static/media/admin.9131d85d.jpg";